<nav class="sidebar">
  <div class="brand" (click)="router.navigateByUrl('/')">
    <div class="logo">CIG</div>
    <div class="name">{{ 'COMMON.APP_NAME' | translate }}</div>
  </div>

  <!-- روابط عامة لجميع المستخدمين -->
  <ul class="menu">
    <li *ngFor="let i of publicItems; trackBy: trackByRoute">
      <a
        [routerLink]="i.route"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: i.route === '/' }"
      >
        <i [class]="iconCls(i.icon)"></i>
        <span class="tx">{{ i.labelKey | translate }}</span>
      </a>
    </li>
  </ul>

  <!-- روابط إدارية (للمسؤولين فقط) -->
  <ul class="menu" *ngIf="hasAdminAccess()">
    <li *ngFor="let i of adminItems; trackBy: trackByRoute">
      <a
        *ngIf="!i.permission || canShowItem(i)"
        [routerLink]="i.route"
        routerLinkActive="active"
      >
        <i [class]="iconCls(i.icon)"></i>
        <span class="tx">{{ i.labelKey | translate }}</span>
      </a>
    </li>
  </ul>

  <div class="spacer"></div>

  <hr class="menu-divider" />

  <!-- روابط في الأسفل -->
  <ul class="menu">
    <li *ngFor="let i of bottomItems; trackBy: trackByRoute">
      <a *ngIf="!i.danger && (!i.permission || canShowItem(i))" [routerLink]="i.route" routerLinkActive="active">
        <i [class]="iconCls(i.icon)"></i>
        <span class="tx">{{ i.labelKey | translate }}</span>
      </a>
      <button *ngIf="i.danger" class="danger" (click)="signOut()">
        <i [class]="iconCls(i.icon)"></i>
        <span class="tx">{{ i.labelKey | translate }}</span>
      </button>
    </li>
  </ul>
</nav>
